import { SimpleSelect } from 'libs/ui';

export const Select2 = (props) => {
  const { items, ...rest } = props;

  const itemsEl = items.map((el, idx) => {
    return (
      <option key={idx} value={el.value}>
        {el.name}
      </option>
    );
  });

  return (
    <SimpleSelect {...rest}>
      {/* <option value="">Все</option> */}
      {itemsEl}
    </SimpleSelect>
  );
};

// Select2.defaultProps = {
//   width: '140px',
//   label: 'Выберите',
//   black: false,
// };
